import { render, staticRenderFns } from "./white_words_list.vue?vue&type=template&id=c961567a"
import script from "./white_words_list.vue?vue&type=script&lang=ts"
export * from "./white_words_list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports